import { useState, useEffect } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import es from "date-fns/locale/es";

registerLocale("es", es)

export default function MyRangeDatePicker({
  appointment,
  handleDateChange,
  disabled,
}) {
  const parseLocalDate = (dateStr) => {
    if (!dateStr) return null;
    const [y, m, d] = dateStr.split("-").map(Number);
    return new Date(y, m - 1, d);
  };

  const formatLocalDate = (date) => {
    return [
      date.getFullYear(),
      String(date.getMonth() + 1).padStart(2, "0"),
      String(date.getDate()).padStart(2, "0"),
    ].join("-");
  };

  const [range, setRange] = useState([
    appointment.startDate ? parseLocalDate(appointment.startDate) : null,
    appointment.endDate ? parseLocalDate(appointment.endDate) : null,
  ]);

  useEffect(() => {
    setRange([
      appointment.startDate ? parseLocalDate(appointment.startDate) : null,
      appointment.endDate ? parseLocalDate(appointment.endDate) : null,
    ]);
  }, [appointment.startDate, appointment.endDate]);

  const [startDate, endDate] = range;

  return (
    <DatePicker
      className="input-base"
      disabled={disabled}
      selectsRange
      startDate={startDate}
      endDate={endDate}
      onChange={(update) => {
        setRange(update);
        const [start, end] = update;
        if (start) {
          handleDateChange("startDate", formatLocalDate(start));
        }
        if (end) {
          handleDateChange("endDate", formatLocalDate(end));
        }
      }}
      placeholderText="Selecciona un rango"
      dateFormat="dd-MM-yyyy"
      inline
      openToDate={startDate || new Date()}
      required
      locale="es"
    />
  );
}
